import React, { Component } from 'react';
import Layout from '../../common/Layout';
import PropTypes from 'prop-types';
// import { Query } from "@apollo/client/react/components"; // TODO: Removed in favor of REST API
import DataTable from '../../common/components/data-table/DataTable';
import Fab from "@material-ui/core/Fab";
import AddIcon from '@material-ui/icons/Add';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import Tooltip from '@material-ui/core/Tooltip';
import plusButtonStyle from '../../settings/otherStyles';
import theme from '../../theme';
// import {client} from '../../settings/apollo'; // TODO: Removed in favor of REST API
import AdminSettingsNavigation from '../adminSettings/AdminSettingsNavigation';
import Select from 'react-select';
// import { GET_USER_GROUPS } from "../userGroup/queries"; // TODO: Replaced with REST hook
import './ChallengeListResults.css';
// import { GET_RESULTS } from "./graphql/queries"; // TODO: Replaced with REST hook useResults
// import { GET_CHALLENGE_DEFINITION_NAMES } from "./graphql/queries"; // TODO: Replaced with REST hook useResultsChallenges
// import { MY_DATA } from "./graphql/queries"; // TODO: Replaced with Zustand store
import moment from 'moment';
import { Navigate } from 'react-router-dom';
import LoadingSpinner from "../../common/components/LoadingSpinner/LoadingSpinner";
import Swal from 'sweetalert2';
import { RolesTypes } from "../../constants/roles";
// import { DELETE_CHALLENGE } from './graphql/mutations'; // TODO: Replaced with REST hook useDeleteResultsChallenge
// import { SecureQuery } from '../../settings/graphqlHelper'; // TODO: Replaced with REST hooks


const columns = ["Name", "Surname", "Challenge Title", "Scores", "Validation Request", "Actions"];
const columnsToHide = ["userExpirationDate"];

class ChallengeListResultsClass extends Component {
  static propTypes = {
    page: PropTypes.number,
    userGroups: PropTypes.array.isRequired, // Receive userGroups as props from wrapper
    userData: PropTypes.object.isRequired, // Receive userData as props from wrapper (replaces MY_DATA)
    challenges: PropTypes.array.isRequired, // Receive challenges as props from wrapper (replaces GET_CHALLENGE_DEFINITION_NAMES)
    resultsData: PropTypes.object, // Results data from useResults hook
    resultsLoading: PropTypes.bool.isRequired, // Loading state from useResults hook
    resultsError: PropTypes.object, // Error from useResults hook  
    refetchResults: PropTypes.func.isRequired, // Function to refetch results
    updateResultsParams: PropTypes.func.isRequired, // Function to update query parameters
    resultsParams: PropTypes.object.isRequired, // Current query parameters
    deleteResultsChallengeMutation: PropTypes.object.isRequired, // Delete challenge mutation from useDeleteResultsChallenge hook
    refetchCounter: PropTypes.number.isRequired, // Counter to force table re-render
    setChallengeOrigineRoute: PropTypes.func, // Function to set challenge origin route
  };

  constructor(props) {
    super(props);
    this.state = {
      name: '',
      page: props.match.params.page ? parseInt(props.match.params.page) : 0,
      selectedIndexes: [],
      users:[],
      // challenges: [], // Now received as props from wrapper
      // challengeList: [], // Now calculated in render from this.props.challenges
      // userGroups: [], // Now received as props from wrapper
      // noChallenges: false, // Now calculated in render
      // userGroup and challenge are now managed via resultsParams prop
    };
    this.handleSelectedIndexes = this.handleSelectedIndexes.bind(this);
    this.handleDeleteAction = this.handleDeleteAction.bind(this);
    this._nextPage = this._nextPage.bind(this);
    this._previousPage = this._previousPage.bind(this);
    this._add = this._add.bind(this);
    this._first = this._first.bind(this);
    this._last = this._last.bind(this);
    this._first = this._first.bind(this);
    this._keyPress = this._keyPress.bind(this);
    this.today = moment();
    // this.client = client; // TODO: Removed in favor of REST API
    this.results = null;
  }

  componentDidMount() {
    // Salva la route corrente nel context quando il componente viene montato
    if (this.props.setChallengeOrigineRoute && this.props.location) {
      this.props.setChallengeOrigineRoute(this.props.location.pathname);
    }
    
    // TODO: Replaced with REST hook useResultsChallenges
    /*
    SecureQuery.query({
      query: GET_CHALLENGE_DEFINITION_NAMES,
    }).then((res) => {
      this.setState({
        challenges: res.data.challengeDefinitionNames,
      });
    }).catch((error) => {
      console.log(error);
    });
    */

    // TODO: Replaced with REST hook useUserGroups
    /*
    SecureQuery.query({
      query: GET_USER_GROUPS
    }).then((res) => {
      this.setState({
        userGroups: res.data.userGroups.records,
      });
    }).catch((error) => {
      console.log(error);
    });
    */
  }

  componentDidUpdate() {
    // Metodo mantenuto per eventuali future necessità
  }

  filteredChallenge = (coachChallenges) => {
    
    if(!this.props.challenges || this.props.challenges.length === 0 || coachChallenges.length === 0) return [];
    
    let challenges = this.props.challenges.map((item, index) => {
      
      if (coachChallenges.length > 0 && coachChallenges.includes(String(item.id))) {
        const result = { value: item.id, label: item.challengeTitle || item.title || item.challengeName || item.name || `Challenge ${item.id}` };
        return result;
      }
      if (coachChallenges.length === 0) {
        const result = { value: item.id, label: item.challengeTitle || item.title || item.challengeName || item.name || `Challenge ${item.id}` };
        return result;
      }
      return null;
    });
    
    const filtered = challenges.filter((item) => item);
    return filtered;
  }

  _previousPage(e) {
    e.preventDefault();
    
    const currentPage = this.props.resultsParams.page;
    if (currentPage > 0) {
      const newPage = currentPage - 1;
      this.setState({ page: newPage }); // Keep local state in sync for URL management
      this.props.updateResultsParams({ page: newPage });
    }
    else {
      this.setState({ page: 0});
      this.props.updateResultsParams({ page: 0 });
    }
  }

  _nextPage(e) {
    e.preventDefault();
    
    const currentPage = this.props.resultsParams.page;
    const newPage = currentPage + 1;
    this.setState({ page: newPage }); // Keep local state in sync for URL management
    this.props.updateResultsParams({ page: newPage });

  }

  _first(e) {
    e.preventDefault();
    this.setState({ page: 0} ); // Keep local state in sync for URL management
    this.props.updateResultsParams({ page: 0 });
   // this.props.history.push('/admin-settings/results')
  }

  _last(pages, e) {
    e.preventDefault();
    const newPage = pages - 1;
    this.setState({ page: newPage }); // Keep local state in sync for URL management
    this.props.updateResultsParams({ page: newPage });
    //this.props.history.push('/admin-settings/results/page/'+(pages - 1))
  }

  _add(event) {
    this.props.history.push("/admin-settings/register");
  }

  _keyPress(e) {
    if (e.keyCode === 13) {
      this.setState({
        name: e.target.value,
        page: 0
      });
    }
  }

  isSelected(user){
    return user._id.this.state.selectedIndexes
  }

  handleSelectedIndexes = (selectedIndexes, records) => {
   this.setState({selectedIndexes: selectedIndexes });
   this.setState({users: records});
  }

  _deleteRow = ({ id }) => {
    const { mutate, isLoading } = this.props.deleteResultsChallengeMutation;
    
    if (isLoading) return; // Prevent multiple calls
    
    mutate(id.id, {
      onSuccess: () => {
        Swal.fire({
          type: "success",
          title: "Challenge Reset successful.",
          showConfirmButton: false,
          timer: 1500
        });
        // Refetch results to update the table
        this.props.refetchResults();
      },
      onError: (error) => {
        console.error('Error deleting challenge:', error);
        Swal.fire({
          type: "error",
          title: "Error while resetting Challenge.",
          showConfirmButton: false,
          timer: 1500
        });
      }
    });
  } 

  handleDeleteAction = (values) => {
    return true;
  }

  highlightRecord (record) {
    return (moment(record.userExpirationDate).isBefore(this.today))
  }


  render() {
   
    return (
      <Layout name="Results">
        <div className="result-list">
          {/* TODO: Replaced Query MY_DATA with Zustand store data passed as props */}
          {(() => {
            // Use userData from props instead of GraphQL MY_DATA query
            const userData = this.props.userData;
            const UserGroupList = []
            const coachGroups = []
            let coachChallenges = [];
            const userGroups = this.props.userGroups.map((item) => ({ value: item._id, label: item.name, groupChallenges: item.groupChallenges })) 
            const courseGroups = userData.courseGroups.map((item) => item)
            courseGroups.map((item) => {
              UserGroupList.push(item._id); 
              coachGroups.push({ value: item._id, label: item.name, groupChallenges: item.groupChallenges }); 
              coachChallenges = coachChallenges.concat(item.groupChallenges);
              return null;
            })
            coachChallenges = coachChallenges.filter((item,index)=> coachChallenges.indexOf(item) === index)
            
            // Calculate the filtered challenges list for the current user group selection
            const currentUserGroup = this.props.resultsParams.userGroup;
            let currentChallengeList;
            
            if (currentUserGroup) {
              // If a user group is selected, get its challenges
              const selectedGroup = userGroups.find(group => group.value === currentUserGroup);
              currentChallengeList = selectedGroup ? this.filteredChallenge(selectedGroup.groupChallenges) : [];
            } else {
              // If no user group is selected
              if (userData.userRole === RolesTypes.SUPERUSER) {
                // SUPERUSER: show ALL challenges from ALL groups
                const allChallenges = userGroups.flatMap(group => group.groupChallenges);
                const uniqueChallenges = [...new Set(allChallenges)]; // Remove duplicates
                currentChallengeList = this.filteredChallenge(uniqueChallenges);
              } else {
                // COACH: show only challenges from their assigned groups
                currentChallengeList = this.filteredChallenge(coachChallenges);
              }
            }
                 
           
            
            return (
              <div className="wizard-container"> 
                {userData.userRole === RolesTypes.SUPERUSER ?
                  <Fab onClick={this._add} color="primary" aria-label="Add" className={plusButtonStyle.fab}>
                    <AddIcon />
                  </Fab>

                  : null}
                <AdminSettingsNavigation path={this.props.match.path} />

                <div className="row justify-content-end result-list__controls">
                  {(<div className="col-xl-3 col-lg-6">
                        <Select
                          styles={{
                            menu: provided => ({ ...provided, zIndex: 9999 })
                          }}
                          onChange={(values) => {
                            if (values != null) {
                              // Quando un gruppo viene selezionato, trova le sue challenge
                              const selectedGroup = userGroups.find(group => group.value === values.value);
                              const groupChallenges = selectedGroup ? this.filteredChallenge(selectedGroup.groupChallenges) : [];
                              
                              // Imposta il primo elemento della lista challenge se esiste, altrimenti null
                              const firstChallenge = groupChallenges.length > 0 ? groupChallenges[0].value : null;
                              
                              this.setState({ page: 0 });
                              this.props.updateResultsParams({ 
                                userGroup: values.value, 
                                challenge: firstChallenge,
                                page: 0 
                              });
                            } else {
                              this.setState({ page: 0 });
                              this.props.updateResultsParams({ 
                                userGroup: null, 
                                challenge: null,
                                page: 0 
                              });
                            }
                          }}
                          options={userData.userRole === RolesTypes.SUPERUSER ? userGroups : coachGroups}
                          isClearable={true}
                          placeholder={"Select course groups"}
                        />
                    </div>
                  )} 
                  
                  <div className="col-xl-3 col-lg-6">
                    <Select
                      styles={{
                        menu: provided => ({ ...provided, zIndex: 9999 })
                      }}
                      value={
                        this.props.resultsParams.challenge 
                          ? currentChallengeList.find(ch => ch.value === this.props.resultsParams.challenge) 
                          : null
                      }
                      onChange={(values) => {
                        if (values != null) {
                          this.setState({ page: 0 });
                          this.props.updateResultsParams({ challenge: values.value, page: 0 });
                        } else {
                          this.setState({ page: 0 });
                          this.props.updateResultsParams({ challenge: null, page: 0 });
                        }
                      }}
                      options={currentChallengeList}
                      placeholder={"Select challenge"}
                      isClearable={true}
                    />
                  </div>
                             
                  {/* Dopo la select "Select challenge", aggiungi questa nuova select */}
                  
                  {/* Nuova select per Status */}
                  <div className="col-xl-3 col-lg-6">
                    <Select
                      styles={{
                        menu: provided => ({ ...provided, zIndex: 9999 })
                      }}
                      onChange={(values) => {
                        if (values != null) {
                          this.setState({ page: 0 });
                          this.props.updateResultsParams({ status: values.value, page: 0 });
                        } else {
                          this.setState({ page: 0 });
                          this.props.updateResultsParams({ status: 'all', page: 0 });
                        }
                      }}
                      options={[
                        { value: 'all', label: 'All' },
                        { value: 'IN_VALIDATION', label: 'Waiting validation' }
                      ]}
                      placeholder={"Select status"}
                      isClearable={true}
                    />
                  </div>
                </div>


                {(() => {
                  const { resultsLoading, resultsError, resultsData } = this.props;
                  
                  if (resultsLoading) return <LoadingSpinner boxed={true} styles={{ paddingTop: 40, marginTop: 15, marginBottom: 30 }} />;
                  if (resultsError) return `Error! ${resultsError.message}`;
                  if (userData.userRole !== RolesTypes.SUPERUSER && userData.userRole !== RolesTypes.COACH) {
                    return <b>This feature is available only to Administrators and Coaches</b>;
                  }

                  if (!resultsData || !resultsData.challengeListResults || !resultsData.challengeListResults.pages) {
                    return <b>No challenges for Challenge Results</b>;
                  }

                  // Aggiungi il campo validationRequest basato sullo status e rimuovi status dai record
                  this.results = {
                    ...resultsData.challengeListResults,
    records: resultsData.challengeListResults.records.map(record => {
                      const { status, ...recordWithoutStatus } = record;
                      let validationIcon = '';
                      if (status === 'IN_VALIDATION') {
                        validationIcon = React.createElement(Tooltip, {
                          title: 'In attesa di validazione',
                          arrow: true
                        }, React.createElement(HelpOutlineIcon, {
                          style: { 
                            color: theme.palette.primary.main, // Stesso colore usato in ResultStep.jsx
                            fontSize: '24px' 
                          }
                        }));
                      }
                      return {
                        ...recordWithoutStatus,
                        'Validation Request': validationIcon
                      };
                    })
                  }
                  const editUrl = {
                    url: '/challenge/end/',
                    editUrlKey: 'editUrlParameter',
                    editUrlParameter: 0
                  }
                  return (
                    <DataTable
                      key={`results-table-${this.props.resultsParams.page}-${resultsData?.challengeListResults?.records?.length || 0}-${this.props.resultsParams.userGroup || 'all'}-${this.props.resultsParams.challenge || 'all'}-${this.props.refetchCounter}`}
                      header='Challenge Results'
                      editUrl={editUrl}
                      pages={resultsData.challengeListResults.pages}
                      columns={columns}
                      columnsToHide={columnsToHide}
                      records={this.results}
                      deleteRow={this._deleteRow}
                      keyColumn='_id'
                      page={this.props.resultsParams.page}
                      first={this._first}
                      last={this._last.bind(this, resultsData.challengeListResults.pages)}
                      next={this._nextPage}
                      previous={this._previousPage}
                      checkboxes={true}
                      selectedIndexes={this.state.selectedIndexes}
                      onSelectedIndex={this.handleSelectedIndexes}
                      showDeleteIcon={this.handleDeleteAction}
                      customDeleteIcon={'rotate_left'}
                      highlightRecord={this.highlightRecord}
                    />
                  );
                })()}
              </div>
            )
          })()}
        </div>
      </Layout>
    );
  }
}

export default ChallengeListResultsClass;